import styled from 'styled-components';

export const SCBeforeUnloadWrapper = styled.div``;
